<script lang="ts">
    import { onMount } from 'svelte';
    import { app } from '../../stores/app';
    // import { clientSettings } from '../../stores/api';
    export let pointClusterDistance: number = 50;
    export let map_key = ''; // get from API or from env
    export let mapPalette: string = 'simple';
    export let ln: string = 'en'; // pl | en
    export let uu: string = '';
    export let mapOptions = {
        container: 'TargeoContainer',
        z: 22,
        c: { y: 52.1565055, x: 21.0464574 },
        area: $app.account?.getSettingsReadonly()?.country !== 'pl' ? 'eu' : 'pl',
        modArguments: {
            Ribbon: { controls: ['MapMenu', 'FTS', 'FindRoute'] },
            Buildings3D: { disabled: false, on: true },
            POI: { disabled: true, submit: false, correct: false, visible: false },
            FTS: { disabled: false },
            FindRoute: { disabled: false, pro_prompt: true },
            Traffic: { disabled: false, visible: false },
            Layers: {
                disabled: false,
                // https://mapa.targeo.pl/docs3/Targeo.modules.Layers.html
                modes: ['map', 'satellite'],
                satsource: ['sentinel', 'geoportal', 'warszawa'],
                mode: 'map',
                control: 'rich',
                setlabels: true,
                minMapDimensionsForControl: [200, 200],
            },
        },
        pointClusterDistance,
    };
    export let onMapLoad: (map: any) => void;

    let isScriptCreated = false;
    let Mapa = Object;
    let loadedLn: string | null = null;

    function createMapScript(callbackWhenFinished: () => void) {
        /*
         script src="https://mapa.targeo.pl/Targeo.html?vn=3_0&v=full&k=...........ZDBkOQ==&m=0&e=TargeoContainer&f=LoadMods&xhr=1"
         */
        if (isScriptCreated) {
            console.warn('isScriptCreated, Script is already created. Dont use this method twice.');
            return false;
        }
        console.info('Create script tag for map');
        let map_script = document.createElement('script');
        // map_script.setAttribute("src", `https://mapa.targeo.pl/Targeo.html?vn=3_0&rv=new&k=${this.map_key}&m=1&f=pageInitialize&e=TargeoMapContainer&ln=pl`);
        // map_script.setAttribute("src", `https://mapa.targeo.pl/Targeo.html?vn=3_0&rv=pro&k=${map_key}&m=1&f=pageInitialize&e=TargeoMapContainer&ln=pl`);
        // map_script.setAttribute("src", `https://mapa.targeo.pl/Targeo.html?vn=3_0&rv=full&k=${map_key}&m=0&f=LoadMods&e=TargeoContainer&ln=pl&xhr=1`);
        map_script.setAttribute(
            'src',
            `https://mapa.targeo.pl/Targeo.html?vn=3_0&k=${map_key}&m=0&f=unusedFunction&e=TargeoContainer&ln=${ln}&xhr=1`+(uu ? '&uu='+uu : '')
        );
        map_script.setAttribute('type', 'text/javascript');
        map_script.setAttribute('data-id', 'TargeoMapScript');
        document.body.appendChild(map_script);
        console.log('TargeoMap, loading language:', ln);
        isScriptCreated = true;
        loadedLn = ln;
        if (typeof callbackWhenFinished === 'function') {
            console.info('Waiting for Targeo defined...');
            let intervalHandler = setInterval(() => {
                // @ts-ignore
                if (typeof Targeo !== 'undefined') {
                    console.info('Targeo defined, clearing interval');
                    clearInterval(intervalHandler);
                    console.info('Targeo defined, running callback');
                    loadMap();
                    callbackWhenFinished();
                }
            }, 250);
        }
        return true;
    }

    function loadMap() {
        mapOptions = {
            ...mapOptions,
            container: 'TargeoContainer',
        };
        // @ts-ignore
        Mapa = new Targeo.Map(mapOptions);
        // @ts-ignore
        Targeo.Base.addCSSs({
            //'/#map #TargeoContainer .targeo-spread-container': 'background: radial-gradient(circle, #fffffffa 0%, #ffffff33 45%, #ffffff00 70%);',
            //'/#map #TargeoContainer .targeo-spread-label': 'background-color: rgba(52, 52, 52, 0.9);',
            //'/#map #TargeoContainer .targeo-spread-spoke': 'stroke: #999',
            '.targeo-spread-label span': 'display: inline-block; margin: 0 3px; font-weight: bold',
            '.targeo-spread-label span:first-child': 'margin-left: 0;',
            '.targeo-spread-label span:last-child': 'margin-right: 0;',
        });

        // Mapa.modules['ContextMenuManager'].registerOption('something', {


        // @ts-ignore
        Mapa.initialize();

        // // map.modules.
        // Mapa.modules.ContextMenu.registerOption('place_warehouse', {
        //     'label': 'something',
        //     'iconUrl': Targeo.Base.getSVGSrc('<path d="M17,10.91v3.77l-.8.78a5.48,5.48,0,0,0-8.4,0L7,14.68V4h3.09a5.51,5.51,0,0,1,.72-2H6.5A1.5,1.5,0,0,0,5,3.5V16l3.65,2a3.49,3.49,0,0,1,6.7,0L19,16V10.19A5.51,5.51,0,0,1,17,10.91Z" fill="#77b024"/><path d="M12,17a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z" fill="#77b024"/><path d="M16,0a5,5,0,1,0,5,5A5,5,0,0,0,16,0Zm3,6H17V8H15V6H13V4h2V2h2V4h2Z" fill="#77b024"/>', 24, 24),
        //     'handler': function (e: any) {
        //         console.log('something');
        //     }
        // });
        // Mapa.modules.ContextMenu.changeContextMenuDefaultOptions({
        //     add: [{before: 0, name: '|'}, {before: 0, name: 'place_warehouse'}]
        // });

        // @ts-ignore
        if (mapPalette && typeof Mapa.setPalette === 'function') Mapa.setPalette(mapPalette);
    }

    function create() {
        createMapScript(() => {
            console.log('TargeoMap, map script created');
        });
        const isTargeoElementAvailable = () => {
            return new Promise((resolve, reject) => {
                const intervalMap = setInterval(() => {
                    console.log('checking for targeo element');
                    // @ts-ignore Targeo is global
                    if (typeof Targeo !== 'undefined') {
                        console.log('Targeo element found');
                        clearInterval(intervalMap);
                        resolve(null);
                    }
                }, 500);
            });
        };

        const isMapElementAvailable = () => {
            return new Promise((resolve, reject) => {
                const intervalMap = setInterval(() => {
                    console.log('checking for map element');
                    // @ts-ignore Mapa is global
                    if (typeof Mapa !== 'undefined') {
                        // console.log('map element found');
                        clearInterval(intervalMap);
                        resolve(null);
                    }
                }, 600);
            });
        };

        const isTargeoBaseMapElementAvailable = () => {
            return new Promise((resolve, reject) => {
                const intervalMap = setInterval(() => {
                    console.log('checking for map element');
                    // @ts-ignore Mapa is global
                    if (typeof Targeo !== 'undefined' && typeof Targeo?.Base?.Map !== 'undefined') {
                        // console.log('map element found');
                        clearInterval(intervalMap);
                        resolve(null);
                    }
                }, 650);
            });
        };

        (async ()=> {
            await Promise.all([
                isMapElementAvailable(),
                isTargeoElementAvailable(),
                isTargeoBaseMapElementAvailable(),
            ]);

            if (typeof onMapLoad === 'function') {
                console.log('callbacks.onMapLoad');
                onMapLoad(Mapa);
            }
        })();
    }

    function removeScript() {
        let script = document.querySelector('script[data-id="TargeoMapScript"]');
        if (script) {
            Mapa = Object;
            if (typeof Targeo !== 'undefined') {
                // @ts-ignore Targeo global
                Targeo = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof _TARGEO_GLOBALS !== 'undefined') {
                // @ts-ignore Targeo global
                _TARGEO_GLOBALS = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof _TARGEO_BROWSER !== 'undefined') {
                // @ts-ignore Targeo global
                _TARGEO_BROWSER = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof ___targeo___analysed___ !== 'undefined') {
                // @ts-ignore Targeo global
                ___targeo___analysed___ = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof ___targeo___Maps___ !== 'undefined') {
                // @ts-ignore Targeo global
                ___targeo___Maps___ = undefined;
            }
            console.log('TargeoMap, remove script');
            script.remove();
            isScriptCreated = false;
        }
    }

    onMount(() => {
        console.info('TargeoMap, map_key', map_key);
        removeScript();
        create();

        return () => {
            console.log('TargeoMap, cleanup');
            removeScript();
        };
    });

    $: {
        if (loadedLn !==null && loadedLn !== ln && isScriptCreated) {
            loadedLn = null;
            console.log('TargeoMap, language selected:', ln);
            removeScript();
            create();
        }
    }

</script>

<div class="map" id="map">
    <a href="https://mapa.targeo.pl/" id="TargeoContainer" title="Mapa Polski" style="height: 100%;"
    ></a>
    <!-- If the map is not loaded, please set your key map in Settings -->
</div>

<style>
    .map {
        height: 100%;
        width: 100%;
        /*z-index:300;*/
    }
</style>
